// @flow
import React, { type Node, type ChildrenArray } from 'react';
import ReactOverlaysModal from 'react-overlays/lib/Modal';
import classNames from 'classnames';
import './Dialog.scss';
import alert from '../../../static/ico-64-alert.svg';

const MAX_BUTTON_COUNT = 3;

type DialogProps = {
  show: boolean,
  onHide?: Function,
  className?: string,
  children: Node
};

type DialogDangerBodyProps = {
  children: Node
};

type DialogControlsProps = {
  children: Node
};

const Dialog = (props: DialogProps) => {
  const { show, children, onHide, className = '' } = props;
  return (
    <ReactOverlaysModal
      backdropClassName={classNames('loc loc-modal-backdrop', className)}
      onHide={onHide}
      show={show}
    >
      <div className={classNames('loc loc-reset loc-dialog', className)}>
        {children}
      </div>
    </ReactOverlaysModal>
  );
};

Dialog.defaultProps = {
  onHide: () => {},
  className: ''
};

export const DialogDangerBody = (props: DialogDangerBodyProps) => (
  <div className="DialogThumbnailBody">
    <div className="DialogThumbnail">
      <span dangerouslySetInnerHTML={{ __html: alert }} />
    </div>
    <div>{props.children}</div>
  </div>
);

export const DialogControls = (props: DialogControlsProps) => {
  let primarySecondaryContainer;
  let tertiaryButton;

  if (!props.children) {
    return <div />;
  }

  if (!Array.isArray(props.children)) {
    primarySecondaryContainer = props.children;
  } else {
    const children = (props.children: ChildrenArray<any>);
    const buttonCount =
      props.children.length > MAX_BUTTON_COUNT
        ? MAX_BUTTON_COUNT
        : props.children.length;
    if (buttonCount === MAX_BUTTON_COUNT) {
      primarySecondaryContainer = children.slice(1, MAX_BUTTON_COUNT);
      tertiaryButton = children.slice(0, 1);
    }

    if (buttonCount < MAX_BUTTON_COUNT) {
      primarySecondaryContainer = children;
    }
  }

  return (
    <div className="DialogControls">
      <div className="DialogControls__Left">{tertiaryButton}</div>
      <div className="DialogControls__Right">{primarySecondaryContainer}</div>
    </div>
  );
};

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/dialogs/Dialog.jsx